// src/Services/Service.jsx

// ON NE FAIT PLUS JAMAIS import du JSON → interdit par Vite/CRA
// ON LE CHARGE AVEC fetch() → c’est la méthode officielle

export async function FetchData() {
  try {
    // En local : http://localhost:3000/bdd_result.json
    // En prod  : https://tonsite.com/bdd_result.json
    const response = await fetch('/bdd_result.json');

    if (!response.ok) {
      const text = await response.text();
      console.error("Fichier non trouvé :", text);
      throw new Error(`Impossible de charger bdd_result.json (HTTP ${response.status})`);
    }

    const data = await response.json();
    console.log(`Données chargées : ${data.length} spécimens`);
    return data;

  } catch (err) {
    console.error("ERREUR FATALE dans FetchData :", err);
    // Message clair dans Galery
    throw new Error("Base de données introuvable. Vérifiez que public/bdd_result.json existe.");
  }
}